import { AnalyticsEventAttribute } from '../../constants/AnalyticsEventAttribute';
import { isMessageModalOpen } from '../../utils/message';
import { MessageModalData } from '../../types/message';
import { useEffect, useState } from 'react';
import {
  Actions,
  Cancel,
  CloseButton,
  CloseIcon,
  Confirm,
  Contents,
  ContentWrapper,
  Description,
  Modal,
  ModalContent,
  Root,
  Title,
} from './MessageModalStyle';

function MessageModal() {
  const [data, setData] = useState<MessageModalData | null>();

  const handleClose = () => {
    data?.closeClickHandler && data.closeClickHandler();
    isMessageModalOpen.next(null);
  };

  useEffect(() => {
    const subscription = isMessageModalOpen.subscribe((e) => {
      setData(e);
    });
    return () => subscription.unsubscribe();
  }, []);

  const renderDescription = () => {
    if (data?.isDescriptionPrebuiltHtml && data?.description) {
      return (
        <Description>
          <div dangerouslySetInnerHTML={{ __html: data.description }} />
        </Description>
      );
    } else {
      return <Description>{data?.description}</Description>;
    }
  };

  return (
    <Root>
      <Modal open={!!data} onClose={handleClose}>
        <ModalContent>
          <ContentWrapper>
            <CloseButton onClick={handleClose}>
              <CloseIcon></CloseIcon>
            </CloseButton>
            <Contents>
              {data?.title && <Title>{data?.title}</Title>}
              {renderDescription()}
            </Contents>
            <Actions>
              {data?.cancelButtonLabel && (
                <Cancel onClick={data?.cancelClickHandler || handleClose}>
                  {data?.cancelButtonLabel}
                </Cancel>
              )}
              {data?.confirmButtonLabel && (
                <Confirm
                  data-event-tracking={
                    data.confirmButtonLabel === '1.888.80.RENTS'
                      ? AnalyticsEventAttribute.MainPhone
                      : ''
                  }
                  onClick={data?.confirmClickHandler}
                >
                  {data?.confirmButtonLabel}
                </Confirm>
              )}
            </Actions>
          </ContentWrapper>
        </ModalContent>
      </Modal>
    </Root>
  );
}

export default MessageModal;
